var _class;
/*
 *                     NOTICE
 *            COPYRIGHT 2020 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbMenuButton } from "abreact/menu/AbMenuButton";
import { observer } from "mobx-react";
import * as React from "react";
/**
 * Idea from discussion with Erik.  todo - move to abreact.
 */
export let AbHamburgerMenuButton = observer(_class = class AbHamburgerMenuButton extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement(AbMenuButton, {
      className: "ab-hamburger-menu-button",
      icon: "absdk:more",
      menuItems: this.props.menuItems
    });
  }
}) || _class;
//# sourceMappingURL=AbHamburgerMenuButton.js.map
